module.exports = __webpack_public_path__ + "img/amazon.bca66596.svg";